import React from 'react';
import { createUseStyles } from 'react-jss';
import Spinner from '../../elements/LoadingSpinner';

interface LoadingOverlayProps {
  isLoading: boolean;
  spinnerSize?: number;
  spinnerColor?: string;
  spinnerBorderColor?: string;
  backgroundColor?: string;
  borderRadius?: number;
}

interface StyleProps {
  backgroundColor: string;
  borderRadius: number;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading,
  spinnerSize,
  spinnerColor,
  spinnerBorderColor,
  backgroundColor = 'rgba(255, 255, 255, 0.7)',
  borderRadius = 8,
}) => {
  const classes = useStyles({ backgroundColor, borderRadius });

  if (!isLoading) return null;

  return (
    <div className={classes.overlay}>
      <Spinner size={spinnerSize} color={spinnerColor} borderColor={spinnerBorderColor} />
    </div>
  );
};

const useStyles = createUseStyles({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: (props: StyleProps) => props.backgroundColor,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
    borderRadius: (props: StyleProps) => props.borderRadius,
  },
});

export default LoadingOverlay;
